module.exports = __webpack_public_path__ + "static/media/missed.baa21b8e.png";